/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SubmittedJob } from './SubmittedJob';
import type { ThermalModelDetails } from './ThermalModelDetails';
/**
 * Motor Lab with the data referenced by ID.
 */
export type MotorTorqueCurvesID = {
    item_type?: MotorTorqueCurvesID.item_type;
    name?: string;
    mass?: number;
    moment_of_inertia?: number;
    cost?: number;
    _id?: string;
    data_id?: (string | null);
    submitted_job?: (SubmittedJob | null);
    thermal_model_details?: ThermalModelDetails;
    component_type?: 'MotorTorqueCurveID';
    voltages?: Array<number>;
};
export namespace MotorTorqueCurvesID {
    export enum item_type {
        COMPONENT = 'component',
    }
}

